// ########################### RefSystem ###########################
export const EM_RefSystem_ICD = 'icd';
export const EM_RefSystem_LOINC = 'loinc';
export const EM_RefSystem_SNOMED = 'snomed';
export const EM_RefSystem_OID = 'oid';
export const EM_RefSystem_RXNORM = 'rxnorm';
export const EM_RefSystem_CPT = 'cpt';
export const EM_RefSystems = [
    EM_RefSystem_ICD,
    EM_RefSystem_LOINC,
    EM_RefSystem_SNOMED,
    EM_RefSystem_OID,
    EM_RefSystem_RXNORM,
    EM_RefSystem_CPT
];
// ########################### RefSystem -> ReferenceType Mapping ###########################
export const RefSystemToReferenceType = {
    [EM_RefSystem_CPT]: 'cpt',
    [EM_RefSystem_ICD]: 'icdCode',
    [EM_RefSystem_LOINC]: 'loinc',
    [EM_RefSystem_SNOMED]: 'snomed',
    [EM_RefSystem_RXNORM]: 'rxCUI',
};
// ########################### Unresolved Code Status ###########################
export const UnresolvedCodeStatus_NewAndWaitingForNLP = 'new_and_waiting_for_nlp';
export const UnresolvedCodeStatus_WaitingForUserDecision = 'waiting_for_user_decision';
export const UnresolvedCodeStatus_Rejected = 'rejected';
export const UnresolvedCodeStatus_ReferenceAddedToExistingHV = 'reference_added_to_existing_hv';
export const UnresolvedCodeStatus_NewHVCreated = 'new_hv_created';
export const UnresolvedCodeStatus_ResolvedEntryId = 'resolved_entry_id';
export const UnresolvedCodeStatuses = [
    UnresolvedCodeStatus_NewAndWaitingForNLP,
    UnresolvedCodeStatus_WaitingForUserDecision,
    UnresolvedCodeStatus_Rejected,
    UnresolvedCodeStatus_ReferenceAddedToExistingHV,
    UnresolvedCodeStatus_NewHVCreated,
    UnresolvedCodeStatus_ResolvedEntryId
];
//# sourceMappingURL=types.js.map